import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section className="relative bg-gradient-to-br from-indigo-600 via-blue-600 to-teal-500 text-white py-24 px-6 overflow-hidden rounded-b-[4rem] shadow-2xl">
      {/* Dynamic background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30">
        <motion.div 
          animate={{ scale: [1, 1.2, 1], rotate: [0, 90, 0] }}
          transition={{ duration: 20, repeat: Infinity }}
          className="absolute -top-24 -left-24 w-[30rem] h-[30rem] bg-white/20 rounded-full blur-[100px]"
        />
        <motion.div 
          animate={{ scale: [1, 1.5, 1], x: [0, 50, 0] }}
          transition={{ duration: 15, repeat: Infinity }}
          className="absolute -bottom-24 -right-24 w-[40rem] h-[40rem] bg-indigo-900/40 rounded-full blur-[120px]"
        />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative max-w-4xl mx-auto text-center"
      >
        <motion.div 
          whileHover={{ scale: 1.1, rotate: 5 }}
          className="inline-flex items-center justify-center p-5 bg-white/10 backdrop-blur-xl rounded-3xl mb-10 shadow-xl border border-white/20"
        >
          <SafeIcon name="MessageCircle" className="w-10 h-10 text-white" />
        </motion.div>
        
        <h1 className="text-5xl md:text-7xl font-black tracking-tight mb-8 leading-[1.1]">
          Parent Discovery
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-teal-200 to-blue-200 mt-2">
            Practice Lab
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl text-blue-50/90 mb-10 max-w-2xl mx-auto leading-relaxed font-medium">
          Master the art of the first conversation. This is a discovery session: you ask the right questions, they share the real story.
        </p>
        
        <div className="flex flex-wrap justify-center gap-4">
          {['Active Listening', 'Strategic Questioning', 'Trust Building'].map((tag, i) => (
            <motion.span 
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.5 + (i * 0.1) }}
              key={tag} 
              className="px-6 py-2 bg-white/10 rounded-2xl border border-white/20 backdrop-blur-md text-sm font-bold uppercase tracking-wider"
            >
              {tag}
            </motion.span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}